// removed by extract-text-webpack-plugin
module.exports = {"field":"_13UI3iOo4TpSL8XqI4JV9j","value":"_1fOEFo09cF4aw5ZURjkv6B","booleanField":"_2eA3yBWsJIn6hPSt_RWq2C","label":"_3UAQLrOiNCW9Y23GXqQpTU"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-593c5ccd","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./~/vue-components/activity-summary/components/custom-section/fields/boolean-field.less
// module id = X4aO
// module chunks = 1